import { FolderOpenOutlined, UserOutlined } from '@ant-design/icons'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function FolderPathAndCreator({
  path,
  createdBy,
}: {
  path: string[] | undefined
  createdBy: string | undefined
}) {
  return (
    <div className="flex flex-wrap justify-between text-gray-400">
      <span className="whitespace-pre-wrap break-words">
        {path !== undefined && path.length > 0 && (
          <div className="flex flex-row items-start gap-x-1">
            <div className="pt-[0.25px]">
              <FolderOpenOutlined />
            </div>
            {path.join(' / ')}
          </div>
        )}
      </span>
      <span className="flex items-start justify-end whitespace-pre-wrap break-words">
        {createdBy !== undefined && createdBy !== '' && (
          <div className="flex flex-row gap-x-1">
            <div>
              <UserOutlined />
            </div>
            {createdBy}
          </div>
        )}
      </span>
    </div>
  )
}
